import { scheduleTask } from 'ember-lifeline';

export function scrollPageToTop(context: object): void {
  scheduleTask(context, 'render', () => {
    window.document.body.scrollTo({ top: 0 });
    window.scrollTo({ top: 0 });
  });
}
